






































import { ref, defineComponent, toRefs, reactive } from '@vue/composition-api'

import { editTextbook } from '@/shared/api'
import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'EditTextbook',
  components: {
    CloseButton,
  },
  props: {
    textbook: Object,
  },
  setup(props, context) {
    const EditTextbookForm = ref(null)
    const data = reactive({
      valid: true,
      name: props.textbook.name,
      nameRules: [(v: string) => !!v || 'name.required'],
    })

    const loading = ref(false)

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = EditTextbookForm.value
      form.validate()
      loading.value = true
      try {
        const editedTextbook = await editTextbook(props.textbook.id, data.name)
        context.emit('textbook-edited', editedTextbook)
      } catch (e) {
        console.error(e)
      }
      loading.value = false
    }

    return {
      ...toRefs(data),
      loading,
      EditTextbookForm,
      submit,
    }
  },
})
